import { ButtonDownload, Typography } from "@tvg/fuse";
import React from "react";
import { Brand } from "../../../../types/brand";
import styles from "./download-app.module.css";

export interface DownloadAppProps {
  brand: Brand;
}

const DownloadApp: React.FC<DownloadAppProps> = ({ brand }) => {
  const isAndroid =
    typeof window !== "undefined" && /android/i.test(navigator.userAgent);
  const isIOS =
    typeof window !== "undefined" &&
    /(iphone|ipad|ipod)/i.test(navigator.userAgent);

  const appleLink =
    brand === Brand.Very
      ? "https://itunes.apple.com/gb/app/myvery-shop-fashion-electricals/id931893198?mt=8"
      : brand === Brand.Littlewoods
        ? "https://itunes.apple.com/gb/app/littlewoods/id1142644536?mt=8"
        : "";

  const googleLink =
    brand === Brand.Very
      ? "https://play.google.com/store/apps/details?id=uk.co.very.myvery"
      : brand === Brand.Littlewoods
        ? "https://play.google.com/store/apps/details?id=com.shopdirect.mylittlewoods"
        : "";

  const showAppleButton = !isAndroid && !!appleLink;
  const showGoogleButton = !isIOS && !!googleLink;

  return (
    <div className={styles.download_app__container} data-testid="download-app">
      <Typography
        size="1"
        tag="h3"
        type="heading"
        className={styles.download_app__title}
        data-testid="download-app-title"
      >
        Download the app
      </Typography>

      <div className={styles.download_app__buttons}>
        {showAppleButton && (
          <ButtonDownload
            href={appleLink}
            alt="Download on the App Store"
            variant="apple"
            size="large"
            data-testid="apple-store-link"
          />
        )}

        {showGoogleButton && (
          <ButtonDownload
            href={googleLink}
            alt="Get it on Google Play"
            variant="google"
            size="large"
            data-testid="google-play-link"
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(DownloadApp);
